<section class="faq-public" aria-labelledby="faq-public-title">
  <app-header-public
    variant="v2"
    [showAuthButtons]="true"
    [showRegisterButton]="false"
  ></app-header-public>

  <div class="home-faq faq-public__body">
    <div class="home-faq__bubble home-faq__bubble--left" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--right" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--left faq-public__bubble--row-2-left" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--right faq-public__bubble--row-2-right" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--left faq-public__bubble--row-3-left" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--right faq-public__bubble--row-3-right" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--left faq-public__bubble--row-4-left" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--right faq-public__bubble--row-4-right" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--left faq-public__bubble--row-5-left" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--right faq-public__bubble--row-5-right" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--left faq-public__bubble--row-6-left" aria-hidden="true"></div>
    <div class="home-faq__bubble home-faq__bubble--right faq-public__bubble--row-6-right" aria-hidden="true"></div>

    <div class="home-faq__inner">
      <div class="home-faq__heading">
        <p class="home-faq__eyebrow">Ayuda</p>
        <h1 id="faq-public-title" class="home-faq__title">
          Preguntas <span class="home-faq__title-accent">frecuentes</span>
        </h1>
      </div>

      @if (cargando) {
        <p class="faq-public__status">Cargando preguntas frecuentes…</p>
      } @else if (!items.length) {
        <p class="faq-public__status">
          No hay preguntas frecuentes disponibles en este momento.
        </p>
      } @else {
        <div class="home-faq__list">
          @for (item of items; track item.orden; let i = $index) {
            <article
              class="home-faq__item"
              [class.home-faq__item--open]="openIndex === i"
              role="button"
              tabindex="0"
              [attr.aria-expanded]="openIndex === i"
              [attr.aria-controls]="'faq-public-answer-' + i"
              (click)="toggleFaq(i)"
              (keydown.enter)="toggleFaq(i)"
              (keydown.space)="toggleFaq(i); $event.preventDefault()"
            >
              <div class="home-faq__summary">
                <span class="home-faq__question">{{ item.pregunta }}</span>
                <span class="home-faq__icon" aria-hidden="true"></span>
              </div>
              <div class="home-faq__answer-wrap" [id]="'faq-public-answer-' + i">
                <div class="home-faq__answer-inner">
                  <p class="home-faq__answer">{{ item.respuesta }}</p>
                </div>
              </div>
            </article>
          }
        </div>
      }

      <div class="faq-public__actions">
        <a
          routerLink="/home"
          class="faq-public__back"
          id="btn-faq-volver"
          (click)="scrollHomeTop()"
        >
          Volver
        </a>
      </div>
    </div>
  </div>

  <app-home-site-footer></app-home-site-footer>
</section>
